/* @refresh reload */
import { render } from "solid-js/web";
import App from "./App";
import "./index.css";
import { registerPwa } from "./pwa";

const root = document.getElementById("root");

if (!root) throw new Error("#root が見つかりません。");

render(() => <App />, root);
registerPwa();
